import { useMemo } from 'react';
import { useGetMessageTemplateOptionsQuery } from '../api';

export type Option = { value: string; label: string };

export const useMessageTemplateOptionsQuery = (
    skip: boolean = false
): {
    options: Option[];
    loading: boolean;
    error?: Error;
    refetch: () => void;
} => {
    const { data, loading, error, refetch } = useGetMessageTemplateOptionsQuery({
        fetchPolicy: 'cache-first',
        skip,
    });

    const options = useMemo<Option[]>(() => {
        const templates = (data?.templates ?? []).filter(t => t.name.toLowerCase().startsWith('pti_'));

        return templates.map(t => ({ value: t.sid, label: t.name }));
    }, [data]);

    return {
        options,
        loading,
        error: error ?? undefined,
        refetch: () => {
            refetch();
        },
    };
};

export const useMessageTemplateOptions = (): Option[] => {
    const { options } = useMessageTemplateOptionsQuery();

    return options;
};
